app.component('homeHeader', {
    templateUrl: 'app/common/component/homeHeader/homeHeader.html',
    transclude: {
        title : "?homeHeaderTitle",
        contents : "?homeHeaderContents",
    }
});